import clsx from "clsx"
import PropTypes from "prop-types"

const NewSelect = ({ options, handleSelectOption, className }) => {
  const onChangeOption = (value) => {
    handleSelectOption(value)
  }
  return (
    <select
      className={clsx(
        "border border-gray1 rounded-lg p-4 flex justify-between items-center h-full bg-[transparent] triangle-down-select-icon search-input text-[12px]",
        className && className,
      )}
      onChange={(e) => onChangeOption(e.target.value)}
    >
      {options.map((option) => {
        return (
          <option key={option.id} value={option.id}>
            {option.name}
          </option>
        )
      })}
    </select>
  )
}

NewSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  handleSelectOption: PropTypes.func,
  className: PropTypes.string,
}

export default NewSelect
